import * as React from 'react';

export const Toolbar = () => {
  return null;
};
